import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/illustrations/email.png'
import _imports_1 from '@/assets/images/icons/bulb.png'


const _withScopeId = n => (_pushScopeId("data-v-4d9ef1a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full relative w-full flex items-center justify-center" }
const _hoisted_2 = { class: "_forgot-password _page-view w-full" }
const _hoisted_3 = {
  key: 0,
  class: "_page-view__title font-bold mb-1 text-neutral-700"
}
const _hoisted_4 = {
  key: 1,
  class: "_page-view__label mb-12 text-neutral-600"
}
const _hoisted_5 = {
  key: 2,
  class: "flex item-center justify-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "150",
  width: "150"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 3,
  class: "_page-view__title font-bold mt-8 mb-10 text-neutral-700 text-center"
}
const _hoisted_9 = { class: "_page-view__content" }
const _hoisted_10 = { class: "mb-12" }
const _hoisted_11 = { class: "input-group input--lg" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label" }, "Email", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "error text-sienna-600"
}
const _hoisted_15 = {
  key: 0,
  class: "my-12"
}
const _hoisted_16 = {
  key: 1,
  class: "text-center text-neutral-600"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 font-medium text-center absolute bottom-10 w-full flex items-center gap-3 justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-6 h-6",
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Tìm hiểu "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://wiki.luca.education/cac-ban-cap-nhat/website",
      class: "font-semibold text-green-500"
    }, "tính năng mới")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.successfully && false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Quên mật khẩu? "))
        : _createCommentVNode("", true),
      (!_ctx.successfully && false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Bạn hãy điền email đã đăng ký với Luca vào ô dưới đây nhé "))
        : _createCommentVNode("", true),
      (_ctx.successfully)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.successfully)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Gửi email thành công "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Địa chỉ email",
              class: "bg-white",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.forgotPasswordData.email) = $event)),
              disabled: _ctx.successfully
            }, null, 8, _hoisted_13), [
              [_vModelText, _ctx.forgotPasswordData.email]
            ])
          ]),
          (_ctx.errorData.email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errorData.email), 1))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.successfully)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "button-p btn--lg",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, " Tiếp tục ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.successfully)
          ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Luca đã gửi hướng dẫn cách thay đổi mật khẩu tới email của bạn. Bạn hãy kiểm tra email để cài đặt mật khẩu mới nhé. "))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_17
  ]))
}